import { NgModule, importProvidersFrom } from '@angular/core';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
// import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { environment } from 'src/environments/environment';
import { DialogService } from 'primeng/dynamicdialog';

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// @NgModule({
    // imports: [
    //     AppLayoutModule,
    //     AppRoutingModule,
    //     TranslateModule.forRoot({
    //         loader: {
    //             provide: TranslateLoader,
    //             useFactory: HttpLoaderFactory,
    //             deps: [HttpClient]
    //         }
    //     })
        
    // ],
//     declarations: [
//         AppComponent,
//     ],
//     providers: [
//         { provide: LocationStrategy, useClass: PathLocationStrategy },
        
//         DialogService
//     ],
//     bootstrap: [AppComponent]
// })
// export class AppModule { }
